module.exports = __webpack_public_path__ + "static/img/backCircle1.b8b6111e.png";